// extracted by mini-css-extract-plugin
module.exports = {"archives":"styles-module--archives--2h5PS","archivesHeader":"styles-module--archivesHeader--1e9IH"};